// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"_3Mopft","fullWidth":"_2oay3x","shine-lines":"_13AI22"};